"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CasaOldSeoManager = _interopRequireDefault(require("./decode/CasaOldSeoManager"));

var _HubPagesSeoManager = _interopRequireDefault(require("./decode/HubPagesSeoManager"));

var _RealEstateSeoManager = _interopRequireDefault(require("./decode/RealEstateSeoManager"));

var _TransactionSeoManager = _interopRequireDefault(require("./decode/TransactionSeoManager"));

var _PublisherSeoManager = _interopRequireDefault(require("./decode/PublisherSeoManager"));

var _SRPPublisherSeoManager = _interopRequireDefault(require("./decode/SRPPublisherSeoManager"));

var _AgentProSeoManager = _interopRequireDefault(require("./decode/AgentProSeoManager"));

var _ImmotypeSeoManager = _interopRequireDefault(require("./decode/ImmotypeSeoManager"));

var _PDPSeoManagaer = _interopRequireDefault(require("./decode/PDPSeoManagaer"));

var _NonAdministrativeZonesSeoManager = _interopRequireDefault(require("./decode/NonAdministrativeZonesSeoManager"));

var _SeoManagerEncoder = _interopRequireDefault(require("./encode/SeoManagerEncoder"));

var _converterHelper = require("./encode/converterHelper");

var _parseUriHelper = require("./helpers/parseUriHelper");

var _utils = require("./helpers/utils");

var _SeoManagerHelpers = require("./helpers/SeoManagerHelpers");

var _home = _interopRequireDefault(require("./meta-specs/home"));

var _index = require("./utils/index");

var _ArticleDataHelper = require("./helpers/ArticleDataHelper");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var WEBSITE_DEFAULT_LANG = {
  'athome.lu': 'fr',
  'athome.de': 'de',
  'immoregion.fr': 'fr',
  'casa.it': 'it'
};
var WEBSITE_LANGS = {
  'athome.lu': ['fr', 'en', 'de'],
  'athome.de': ['en', 'de'],
  'immoregion.fr': ['fr'],
  'casa.it': ['it']
};
var REGEXP = {}; // AgencySeoManager - work in progress!!!!
// const PLIST = [CasaOldSeoManager, AgencySeoManager, TransactionSeoManager, ImmotypeSeoManager, RealEstateSeoManager];

var PLIST = [_SRPPublisherSeoManager["default"], _AgentProSeoManager["default"], _PublisherSeoManager["default"], _PDPSeoManagaer["default"], _HubPagesSeoManager["default"], _NonAdministrativeZonesSeoManager["default"], _CasaOldSeoManager["default"], _TransactionSeoManager["default"], _ImmotypeSeoManager["default"], _RealEstateSeoManager["default"]];
PLIST.map(function (manager) {
  var gls1 = manager.getLevel1Slug();
  REGEXP[gls1.type] = {
    regexp: gls1.isRegExp ? gls1.regexp : gls1.regexp.join('|'),
    cl: manager
  };
});

var startsWithAlt = function startsWithAlt(str, match) {
  return str.indexOf(match) === 0;
};

var endsWithAlt = function endsWithAlt(str, match) {
  return str.lastIndexOf(match) === str.length - match.length;
};

var SeoManager = /*#__PURE__*/function () {
  function SeoManager(domain, lang) {
    _classCallCheck(this, SeoManager);

    this.domain = domain || 'casa.it';
    this.lang = lang || 'it';
    this.supported_lang_slug = WEBSITE_LANGS[this.domain] || ['en'];
    this.original_url = undefined;
    this.obj_manager = undefined;
  }
  /**
   * This function returns an url from a list of filters.<br/>
   * Based on the order of the conditions for every filter in a object it gives a position.<br/>
   * So if in the params there are: `{tr: 'vendita', propertyTypeGroup: 'commerciale'}`, if the condition of tr is before of other one then it will create this kind of url: /vendita/commerciale/
   * <i>SeoManager must be instanced before use it.</i><br/>
   * @param {Object} params list of filters
   * @returns {String} URL
   * @example
   * const seoManager = new SeoManager(domain, lang);
   * seoManager.encode(params);
   */


  _createClass(SeoManager, [{
    key: "encode",
    value: function encode(params) {
      var obj_manager = new _SeoManagerEncoder["default"](this.domain, this.lang);
      return obj_manager.encode(params);
    }
  }, {
    key: "encodeHrefLang",
    value: function encodeHrefLang(params) {
      var obj_manager = new _SeoManagerEncoder["default"](this.domain, this.lang, this.supported_lang_slug);
      return obj_manager.encodeHrefLang(params);
    }
  }, {
    key: "convertParamsForEncode",
    value: function convertParamsForEncode(lang, params) {
      var isOldSeoUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      return (0, _converterHelper.convertParamsForEncode)(lang, params, isOldSeoUrl);
    }
  }, {
    key: "finalSrpUrlToLangUrl",
    value: function finalSrpUrlToLangUrl(final_url) {
      var def_lang = WEBSITE_DEFAULT_LANG[this.domain];

      if (this.lang === def_lang) {
        return final_url;
      } else {
        final_url = "/".concat(this.lang).concat(final_url);
      }

      return final_url;
    }
  }, {
    key: "encodeSrpHrefLangForHeader",
    value: function encodeSrpHrefLangForHeader(uri) {
      var _this = this;

      uri = uri.replace('/en/', '/').replace('/de/', '/').replace('/fr/', '/').replace('/it/', '/');
      var href_lang = {};
      var ret = {};
      this.supported_lang_slug.map(function (l) {
        href_lang[l] = _this.finalSrpUrlToLangUrl(uri);

        if (WEBSITE_DEFAULT_LANG[_this.domain] === l) {
          ret.canonical = href_lang[l];
          ret.seo = '';
          ret.srp = href_lang[l];
          ret.srpMap = href_lang[l].replace('/srp/', '/srp/map/');
        }

        ret.hreflang = href_lang;
      });
      return ret.hreflang[this.lang];
    }
  }, {
    key: "encodeSrpHrefLang",
    value: function encodeSrpHrefLang(uri) {
      var _this2 = this;

      uri = uri.replace('/en/', '/').replace('/de/', '/').replace('/fr/', '/').replace('/it/', '/');
      var t = (0, _SeoManagerHelpers.getTypeOfPageFromUri)(uri);
      var pagetype = !t.lista && t.page && t.page > 1 ? "?page=".concat(t.page) : '';
      var href_lang = {};
      var ret = {};
      this.supported_lang_slug.map(function (l) {
        href_lang[l] = "".concat(_this2.finalSrpUrlToLangUrl(uri).split(/[?#]/)[0]).concat(!t.lista ? '/' : '').concat(pagetype);

        if (WEBSITE_DEFAULT_LANG[_this2.domain] === l) {
          ret.canonical = href_lang[l];
          ret.seo = '';
          ret.srp = href_lang[l].replace(/\/srp\/map\/*$|\/srp\/map\/\?|\/srp\/map\/$/g, '/srp/');
          ret.srpMap = href_lang[l].replace(/\/srp\/*$|\/srp\/\?|\/srp\/$/g, '/srp/map/');
        }

        ret.hreflang = href_lang;
      });
      return ret;
    }
  }, {
    key: "normalizePath",
    value: function normalizePath(path) {
      if (!startsWithAlt(path, '/')) {
        path = "/".concat(path);
      }

      if (!endsWithAlt(path, '/')) {
        path = "".concat(path, "/");
      }

      return path;
    }
  }, {
    key: "removeLang",
    value: function removeLang(url) {
      var ret_url = this.normalizePath(url);
      var tmp_url = ret_url.split('/').slice(1, -1);

      if (this.supported_lang_slug.indexOf(tmp_url[0]) > -1) {
        ret_url = tmp_url.slice(1, tmp_url.length).join('/');
        ret_url = "/".concat(ret_url, "/");
      }

      return ret_url;
    }
  }, {
    key: "normalizeChars",
    value: function normalizeChars(url) {
      url = url.replace('/+', '%2f+');
      return url;
    }
  }, {
    key: "getQueryObject",
    value: function getQueryObject(parts_qo, params_qo) {
      // console.log('*** getQueryObject (parts_qo) ->', parts_qo)
      // console.log('*** getQueryObject (params_qo) ->', params_qo)
      var clearQO = function clearQO(qo) {
        if (!qo) {
          return qo;
        }

        Object.keys(qo).map(function (k) {
          switch (k.toLowerCase()) {
            case 'exteriorfeatures':
              var gardenType = [];
              qo[k] = Array.isArray(qo[k]) ? qo[k][0] : qo[k];
              qo[k].split(/,/g).map(function (ef) {
                switch (ef.toLocaleLowerCase()) {
                  case 'giardino-giardino-comune':
                  case 'giardino-giardinocomune':
                  case 'giardino-comune':
                  case 'giardino-giardino-privato':
                  case 'giardino-giardinoprivato':
                  case 'giardino-privato':
                    gardenType.push(ef.replace(/giardino-giardino/g, 'giardino'));
                    break;

                  case 'privato':
                  case 'comune':
                    gardenType.push("giardino-".concat(ef));
                    break;

                  case 'balcone':
                    qo.balcony = true;
                    break;

                  case 'terrazzo':
                    qo.terrace = true;
                    break;

                  default:
                    break;
                }
              });

              if (gardenType.length > 0) {
                qo.garden = gardenType;
              }

              delete qo.exteriorFeatures;
              break;

            case 'heatingtype':
              qo[k] = Array.isArray(qo[k]) ? qo[k] : qo[k].split(/,/g);
              break;

            case 'misc':
              if (qo[k] === undefined) {
                delete qo[k];
              }

              break;

            default:
              break;
          }
        });
        return qo;
      };

      if (params_qo && parts_qo && parts_qo.numParkingSpaces) {
        params_qo.numParkingSpaces = parts_qo.numParkingSpaces;
      }

      ;

      if (params_qo && parts_qo && parts_qo.lift) {
        params_qo.lift = parts_qo.lift;
      }

      ;
      return Object.assign({}, clearQO(parts_qo), clearQO(params_qo) || null);
    }
    /**
     * This function returns a list of filters from an url.<br/>
     * 1. It checks what kind of url is (PDP, SRP, SEOSRP...).<br/>
     * 2. It splits the urls based on a different REGEXP.<br/>
     * 3. It tries to understand what kind of filter has every value splitted.<br/>
     * <i>SeoManager must be instanced before use it.</i><br/>
     * @param {String} url url to decode
     * @returns {Object} with all the filters known and the type of the url given.
     * @example
     * const seoManager = new SeoManager(domain, lang);
     * seoManager.decode(url);
     */

  }, {
    key: "decode",
    value: function decode(url) {
      var _this3 = this;

      var found = false;
      var params = {};
      this.original_url = url;
      var parts = this.extractPath(url);
      url = parts.uri;
      url = this.removeLang(url);
      url = this.normalizeChars(url);
      var url_level_length = url.split('/').filter(Boolean).length;
      var url_level_1 = url.split('/').filter(Boolean)[0];
      Object.keys(REGEXP).map(function (key, idx) {
        if (!found) {
          var regexp = REGEXP[key].regexp;
          var r = new RegExp(regexp, 'g');

          if (key === _SeoManagerHelpers.HELPER_MANAGER_TYPE.IT) {
            url_level_1 = (0, _SeoManagerHelpers.getStrCategoryImmotype)(_this3.lang, url_level_1);
          }

          var test = false;

          if (key === _SeoManagerHelpers.HELPER_MANAGER_TYPE.PDP) {
            var posListinId = url_level_length > 2 ? url_level_length - 2 : url_level_length - 1;
            var url_level_pdp = url.split('/').filter(Boolean)[posListinId];
            test = r.test(url_level_pdp);
          } else if (key === _SeoManagerHelpers.HELPER_MANAGER_TYPE.AGSRP) {
            test = r.test(_this3.original_url);
          } else if (key === _SeoManagerHelpers.HELPER_MANAGER_TYPE.APRO) {
            test = r.test(_this3.original_url);
          } else {
            test = r.test(url_level_1);
          }

          if (test) {
            found = true;
            _this3.obj_manager = new REGEXP[key].cl(_this3.domain, _this3.lang);
            params = _this3.obj_manager.decode(url);
          }
        }
      });
      params.queryObject = this.getQueryObject(parts.queryObject, params.queryObject);
      return params;
    }
    /**
     * This function checks if is an old seo url.<br/>
     * <i>SeoManager must be instanced before use it.</i><br/>
     * @param {String} uri any string
     * @returns {Boolean} true if the input is an old SEO URL
     * @example
     * const seoManager = new SeoManager(domain, lang);
     * seoManager.decode(url);
     * const isOldSeoUrl = seoManager.isOldSeoUrl(url);
     */

  }, {
    key: "isOldSeoUrl",
    value: function isOldSeoUrl(uri) {
      return this.decode(uri).seo_manager_type === 'old-seo-url';
    }
    /**
     * This function checks if an url is valid.<br/>
     * It checks if all the level of the splitted url are in the place where they should be.<br/>
     * For example level /vendita/ has to be always for an srp at the first level.<br/>
     * <i>SeoManager must be instanced before use it.</i><br/>
     * @returns {Boolean} true if is a valid URL
     * @example
     * const seoManager = new SeoManager(domain, lang);
     * seoManager.decode(url);
     * const isValid = seoManager.isValidDecode();
     */

  }, {
    key: "isValidDecode",
    value: function isValidDecode() {
      try {
        return this.obj_manager.isValidDecode();
      } catch (error) {
        return false;
      }
    }
    /**
     * This function returns apiParams for esapi<br/>
     * <i>SeoManager must be instanced before use it.</i><br/>
     * @returns {Object} that contains params to call esapi.
     * @example
     * const seoManager = new SeoManager(domain, lang);
     * seoManager.decode(url);
     * const apiParams = seoManager.getApiParams();
     */

  }, {
    key: "getApiParams",
    value: function getApiParams() {
      var isSrpUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.obj_manager) {
        return this.obj_manager.getApiParams(isSrpUrl);
      }

      return {};
    }
    /**
     * This function returns seoData: h1, title, metadata<br/>
     * <i>SeoManager must be instanced before use it.</i><br/>
     * @param {Object} locations array of locations
     * @param {number} total_listings any number 
     * @param {Object} moreDetail object with specific data, used especially for pdp seoData
     * @param {Object} prtFilters object with filters from portal, useful for more data (especially AgencySrp) 
     * @returns {Object} that contains {seo: {title, description, h1, h2, robots, meta, mainTitle}}
     * @example
     * const seoManager = new SeoManager(domain, lang);
     * seoManager.decode(url);
     * const helmet = seoManager.getSeoData({[], 14000, {}, {}});
     */

  }, {
    key: "getSeoData",
    value: function getSeoData() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          locations = _ref.locations,
          total_listings = _ref.total_listings,
          moreDetail = _ref.moreDetail,
          _ref$prtFilters = _ref.prtFilters,
          prtFilters = _ref$prtFilters === void 0 ? {} : _ref$prtFilters,
          _ref$seoParams = _ref.seoParams,
          seoParams = _ref$seoParams === void 0 ? {} : _ref$seoParams,
          _ref$isSrpUrl = _ref.isSrpUrl,
          isSrpUrl = _ref$isSrpUrl === void 0 ? false : _ref$isSrpUrl;

      if (this.obj_manager) {
        return this.obj_manager.getSeoData({
          locations: locations,
          total_listings: total_listings,
          moreDetail: moreDetail,
          prtFilters: prtFilters,
          seoParams: seoParams,
          isSrpUrl: isSrpUrl
        });
      }

      return {};
    }
  }, {
    key: "getSeoPageLinks",
    value: function getSeoPageLinks(pages) {
      if (this.obj_manager) {
        return this.obj_manager.getSeoPageLinks(pages);
      }

      return {};
    }
  }, {
    key: "getImmoTypeLang",
    value: function getImmoTypeLang(lang) {
      return (0, _SeoManagerHelpers.getImmotype)(lang);
    }
  }, {
    key: "getImmoTypeLangKey",
    value: function getImmoTypeLangKey(lang) {
      return (0, _SeoManagerHelpers.getImmotypeLK)(lang);
    }
  }, {
    key: "getDefaultSeoData",
    value: function getDefaultSeoData(locations, total_listing) {
      var _this4 = this;

      var params = {
        seo_decode_type: {
          level1: 'home'
        },
        SEO_SRP_SPECS: _home["default"],
        domain: this.domain,
        lang: this.lang
      };
      var brand = this.domain;
      this.seo_data = {
        seo: (0, _SeoManagerHelpers.getSeoDataFromJson)(params)
      };
      Object.keys(this.seo_data.seo).map(function (el) {
        // TODO - eval doesn't work on internet explorer
        // this.seo_data.seo[el] = eval('`' + this.seo_data.seo[el] + '`');
        if (typeof _this4.seo_data.seo[el] === 'string') {
          try {
            _this4.seo_data.seo[el] = _this4.seo_data.seo[el].replace('${brand}', brand).replace('${total_listing}', total_listing);
          } catch (e) {}
        } else {
          _this4.seo_data.seo[el] = _this4.domain;
        }
      });
      delete this.seo_data.seo.h1;
      delete this.seo_data.seo.h2;
      var ret = {
        breadcrumb: [],
        seo: this.seo_data.seo
      };
      return ret;
    }
  }, {
    key: "getUrlsHomeSeoData",
    value: function getUrlsHomeSeoData() {
      var locale = WEBSITE_DEFAULT_LANG[this.domain];
      var canonical = locale === this.lang ? '/' : "/".concat(this.lang, "/");

      switch (this.domain) {
        default:
        case 'athome.lu':
          return {
            canonical: canonical,
            hreflang: {
              fr: '/',
              de: '/de/',
              en: '/en/'
            }
          };

        case 'athome.de':
          return {
            canonical: canonical,
            hreflang: {
              fr: '/fr/',
              de: '/',
              en: '/en/'
            }
          };

        case 'immoregion.fr':
          return {
            canonical: canonical,
            hreflang: {
              fr: '/'
            }
          };
      }
    }
  }, {
    key: "getHomeSeoData",
    value: function getHomeSeoData(total_listing) {
      var _this5 = this;

      var params = {
        seo_decode_type: {
          level1: 'home'
        },
        SEO_SRP_SPECS: _home["default"],
        domain: this.domain,
        lang: this.lang
      };
      var brand = this.domain;
      this.seo_data = {
        seo: (0, _SeoManagerHelpers.getSeoDataFromJson)(params)
      };
      Object.keys(this.seo_data.seo).map(function (el) {
        // TODO - eval doesn't work on internet explorer
        // this.seo_data.seo[el] = eval('`' + this.seo_data.seo[el] + '`');
        if (typeof _this5.seo_data.seo[el] === 'string') {
          try {
            _this5.seo_data.seo[el] = _this5.seo_data.seo[el].replace('${brand}', brand).replace('${total_listing}', total_listing);
          } catch (e) {}
        } else {
          _this5.seo_data.seo[el] = _this5.domain;
        }
      });
      var ret = {
        breadcrumb: [],
        seo: this.seo_data.seo,
        urls: this.getUrlsHomeSeoData()
      };
      return ret;
    }
  }, {
    key: "runPublisherIdRegex",
    value: function runPublisherIdRegex(uri) {
      var publisherIdRegex = /-[0-9]{1,8}(\/\/|\/)?(.+)$/g;
      publisherIdRegex.lastIndex = 0;

      try {
        var matched = uri.match(publisherIdRegex);

        if (matched) {
          return true;
        }
      } catch (error) {
        return false;
      }

      return false;
    }
  }, {
    key: "extractPath",
    value: function extractPath(uri) {
      var pos;
      var parts = {};
      parts.originalUri = uri; // extract fragment

      pos = uri.indexOf('#');

      if (pos > -1) {
        parts.fragment = uri.substring(pos + 1) || null;
        uri = uri.substring(0, pos);
      } // extract query


      pos = uri.indexOf('?');

      if (pos > -1) {
        parts.query = uri.substring(pos + 1) || null;
        parts.queryObject = (0, _parseUriHelper.parseQueryString)(parts.query);
        uri = uri.substring(0, pos);
      } else {
        parts.query = '';
        parts.queryObject = {};
      }

      if (!('surrounding' in parts.queryObject)) {
        if (parts.queryObject.includeSurrounding) {
          parts.queryObject.surrounding = parts.queryObject.includeSurrounding;
        } else {
          delete parts.queryObject.surrounding;
        }
      }

      if (!('sortType' in parts.queryObject)) {
        if (parts.queryObject.activeSort && Array.isArray(parts.queryObject.activeSort)) {
          parts.queryObject.activeSort = parts.queryObject.activeSort[0];
        }

        if (parts.queryObject.activeSort) {
          parts.queryObject.sortType = parts.queryObject.activeSort.replace(/-/g, '-');
        } else {
          delete parts.queryObject.sortType;
        }
      }

      if (!('photo' in parts.queryObject)) {
        parts.queryObject.misc = parts.queryObject.misc && Array.isArray(parts.queryObject.misc) ? parts.queryObject.misc[0] : parts.queryObject.misc;

        if (parts.queryObject.misc === 'photo-only') {
          parts.queryObject.photo = true;
        }
      }
      /**
       * Publisher with _ in slug name as /agenzie/homy_lab-1152139/
       */


      if (uri.indexOf('/agenzie/') === 0 && this.runPublisherIdRegex(uri)) {
        parts.uri = uri;
      } else {
        parts.uri = uri.replace(/_/g, '-');
      }

      if ('zone' in parts.queryObject) {
        var zones = Array.isArray(parts.queryObject.zone) ? parts.queryObject.zone : parts.queryObject.zone.split(',');
        var zonesOK = [];
        zones.map(function (z) {
          if (!isNaN(z)) {
            z = "Z-".concat(z);
          }

          zonesOK.push(z);
        });
        parts.queryObject.zone = zonesOK.join(',');
      }

      return parts;
    }
  }]);

  return SeoManager;
}();

var staticMethods = {
  isSrpUrl: _index.isSrpUrl,
  getAllPropertyTypesSingular: _index.getAllPropertyTypesSingular,
  getAllPropertyTypesPlural: _index.getAllPropertyTypesPlural,
  getBuldingConditionsEncode: _index.getBuldingConditionsEncode,
  getObjByCategoryImmotype: _index.getObjByCategoryImmotypeStatic,
  getPropertyTypes: _index.getPropertyTypes,
  getPublisherTypeEncode: _index.getPublisherTypeEncode,
  getPropertyTypeGroup: _index.getPropertyTypeGroup,
  getRoomsEncode: _index.getRoomsEncode,
  getRoomsDecode: _index.getRoomsDecode,
  getNewZones: _index.getNewZones,
  getNewZonesFrom: _index.getNewZonesFrom,
  getPluralPropertyType: _index.getPluralPropertyType,
  getPluralLTgGroup: _index.getPluralLTgGroup,
  middlewareRedirector: _index.middlewareRedirector,
  middlewareRedirectorPublishers: _index.middlewareRedirectorPublishers,
  middlewareRedirectorPublishersSrp: _index.middlewareRedirectorPublishersSrp,
  middlewareRedirectorSEOPages: _index.middlewareRedirectorSEOPages,
  middlewareRedirectorUnregisteredPages: _index.middlewareRedirectorUnregisteredPages,
  getProvinceList: _index.getProvinceList,
  formatDescription: _ArticleDataHelper.formatDescription,
  createArticleTitleRowsForWeb: _ArticleDataHelper.createArticleTitleRowsForWeb,
  getProvincesByShort: _index.getProvincesByShort,
  getSortValuePart: _index.getSortValuePart,
  checkIfSmallTown: _index.checkIfSmallTown,
  normalizePublisherUrl: _utils.normalizePublisherUrl,
  hasMasterSearchCanonical: _index.hasMasterSearchCanonical,
  isTorinoProvinceTown: _index.isTorinoProvinceTown
};
Object.keys(staticMethods).forEach(function (item) {
  return SeoManager[item] = staticMethods[item];
});
var _default = SeoManager;
exports["default"] = _default;